/* eslint-disable complexity */
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { INoteModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import { IMenuEventParams } from '@src/slide/application/service/menu-manager/menu-event/menu-event.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { IEmptyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/empty-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import * as connectorEvent from '@src/slide/application/service/menu-manager/menu-event/model/connector';
import * as pictureEvent from '@src/slide/application/service/menu-manager/menu-event/model/picture';
import * as shapeEvent from '@src/slide/application/service/menu-manager/menu-event/model/shape';
import * as tableEvent from '@src/slide/application/service/menu-manager/menu-event/model/table';
import * as emptyEvent from '@src/slide/application/service/menu-manager/menu-event/model/empty';
import * as multiplyEvent from '@src/slide/application/service/menu-manager/menu-event/model/multiply';
import * as chartEvent from '@src/slide/application/service/menu-manager/menu-event/model/chart';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';

/**
 * 基础公共事件
 */
export {
    handleCommonMenuEvent,
} from '@src/slide/application/service/menu-manager/menu-event/common';

/**
 * 各model独有的事件
 * @param model
 * @param menuEventParams
 */
export function handleModelMenuEvent(model: IBaseModel | INoteModel, menuEventParams: IMenuEventParams): boolean {
    const modelType = model.type;
    // 连接线
    if ([UIModelType.CONNECTOR].includes(modelType)) {
        return connectorEvent.handleMenuEvent(model as IConnectorModel, menuEventParams);
    }
    // 图片
    if ([UIModelType.IMAGE].includes(modelType)) {
        return pictureEvent.handleMenuEvent(model as IPictureModel, menuEventParams);
    }
    // 形状
    if ([UIModelType.SHAPE].includes(modelType)) {
        return shapeEvent.handleMenuEvent(model as IShapeModel, menuEventParams);
    }
    // 表格
    if ([UIModelType.TABLE].includes(modelType)) {
        return tableEvent.handleMenuEvent(model as ITableModel, menuEventParams);
    }
    // 空白
    if ([UIModelType.EMPTY].includes(modelType)) {
        return emptyEvent.handleMenuEvent(model as IEmptyModel, menuEventParams);
    }
    // 备注
    if ([UIModelType.NOTE].includes(modelType)) {
        const { noteTextBody } = model as INoteModel;
        return !!noteTextBody && shapeEvent.handleMenuEvent(noteTextBody, menuEventParams);
    }
    // 组合
    if ([UIModelType.GROUP].includes(modelType)) {
        return multiplyEvent.batchedHandleMenuEvent((model as IGroupModel).children, menuEventParams);
    }
    // 多选
    if ([UIModelType.MULTIPLY].includes(modelType)) {
        return multiplyEvent.batchedHandleMenuEvent((model as IMultiplyModel).selectedModels, menuEventParams);
    }
    // 图表
    if ([UIModelType.CHART].includes(modelType)) {
        return chartEvent.handleMenuEvent(model as IChartModel, menuEventParams);
    }
    return false;
}
